import { render, staticRenderFns } from "./wxsdevices-add-or-update.vue?vue&type=template&id=bd4b44de&"
import script from "./wxsdevices-add-or-update.vue?vue&type=script&lang=js&"
export * from "./wxsdevices-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports